const IsInEditorText = (isInEditor: boolean, text: string, errorMessage?: string, isCustomMessage?: boolean) => {
  if (!isInEditor) return null
  else if (errorMessage) {
    return (
      <div className='editor-error-text'>
        {text} {errorMessage}
      </div>
    )
  } else if (isCustomMessage) {
    return <div className='editor-text'>{text}</div>
  }
  return <div className='editor-text'>Edit {text} Component</div>
}

export default IsInEditorText
